import { render, staticRenderFns } from "./account-settings-modal.vue?vue&type=template&id=7086bb8e&scoped=true&"
import script from "./account-settings-modal.vue?vue&type=script&lang=ts&"
export * from "./account-settings-modal.vue?vue&type=script&lang=ts&"
import style0 from "./account-settings-modal.vue?vue&type=style&index=0&id=7086bb8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7086bb8e",
  null
  
)

export default component.exports